import { createCriteriaSchema } from 'Validation';
import { Formik } from 'formik';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Input from '@material-ui/core/Input';
// import InputLabel from '@material-ui/core/InputLabel';
import React from 'react';
// import Select from '@material-ui/core/Select';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Select from 'react-select';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import NoSsr from '@material-ui/core/NoSsr';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import Chip from '@material-ui/core/Chip';
import MenuItem from '@material-ui/core/MenuItem';
import CancelIcon from '@material-ui/icons/Cancel';
import { emphasize } from '@material-ui/core/styles/colorManipulator';
import axios from 'Axios';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Snackbar from 'Snackbar';

import 'CSS/main.scss';

const styles = theme => ({
  root: {
    flexGrow: 1,
    height: 300,
  },
  input: {
    display: 'flex',
    padding: 0,
  },
  valueContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    flex: 1,
    alignItems: 'center',
    overflow: 'hidden',
  },
  chip: {
    margin: `${theme.spacing.unit / 2}px ${theme.spacing.unit / 4}px`,
  },
  chipFocused: {
    backgroundColor: emphasize(
      theme.palette.type === 'light'
        ? theme.palette.grey[300]
        : theme.palette.grey[700],
      0.08
    ),
  },
  noOptionsMessage: {
    padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
  },
  singleValue: {
    fontSize: 16,
  },
  placeholder: {
    // position: 'absolute',
    left: 2,
    fontSize: 16,
  },
  divider: {
    height: theme.spacing.unit * 2,
  },
});

function NoOptionsMessage(props) {
  return (
    <Typography
      color="textSecondary"
      className={props.selectProps.classes.noOptionsMessage}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}

function inputComponent({ inputRef, ...props }) {
  return <div ref={inputRef} {...props} />;
}

function Control(props) {
  return (
    <TextField
      fullWidth
      InputProps={{
        inputComponent,
        inputProps: {
          className: props.selectProps.classes.input,
          inputRef: props.innerRef,
          children: props.children,
          ...props.innerProps,
        },
      }}
      {...props.selectProps.textFieldProps}
    />
  );
}

function Option(props) {
  return (
    <MenuItem
      buttonRef={props.innerRef}
      selected={props.isFocused}
      component="div"
      style={{
        fontWeight: props.isSelected ? 500 : 400,
      }}
      {...props.innerProps}
    >
      {props.children}
    </MenuItem>
  );
}

function Placeholder(props) {
  return (
    <Typography
      color="textSecondary"
      className={props.selectProps.classes.placeholder}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}

function SingleValue(props) {
  return (
    <Typography
      className={props.selectProps.classes.singleValue}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}

function ValueContainer(props) {
  return (
    <div className={props.selectProps.classes.valueContainer}>
      {props.children}
    </div>
  );
}

function MultiValue(props) {
  return (
    <Chip
      tabIndex={-1}
      label={props.children}
      className={classNames(props.selectProps.classes.chip, {
        [props.selectProps.classes.chipFocused]: props.isFocused,
      })}
      onDelete={props.removeProps.onClick}
      deleteIcon={<CancelIcon {...props.removeProps} />}
    />
  );
}

function Menu(props) {
  return (
    <Paper square className="menuAddCriteria" {...props.innerProps}>
      {props.children}
    </Paper>
  );
}

const components = {
  Control,
  Menu,
  MultiValue,
  NoOptionsMessage,
  Option,
  Placeholder,
  SingleValue,
  ValueContainer,
};

class AddNewCriteriaDialog extends React.Component {
  state = {
    group: [],
    properties: null,
    selectedGroup: null,
    selectedProperties: null,
    suggestionProperties: null,
    suggestionCriteria: [],
    errorMessage: '',
    choiceForAdding: 'Criteria',
    choiceForAddRemove: 'Add',
    criteriaName: '',
    criteriaMapByUser: null,
    propertiesMapByUser: null,
    selectedCriteriaForDelete: null,
    selectedPropertieForDelete: null,
    msg: '',
    openSnackbar: false,
    criteriaNameEdited: '',
  };
  componentDidMount() {
    this.getAllCriterias();
    // this.getMyCriteria();
  }

  handleCloseSncakbar = () => {
    this.setState({ openSnackbar: false, msg: '' });
  };

  getMyCriteria = () => {
    axios
      .get('criteria/custom')
      .then(response => {
        if (response.data) {
          let criteriaMapByUser = response.data.map(suggestion => ({
            value: suggestion.id,
            label: suggestion.name,
            parentId: suggestion.parentId,
          }));
          let propertiesMapByUser = response.data
            .filter(item => item.parentId === 332)
            .map(suggestion => ({
              value: suggestion.id,
              label: suggestion.name,
              parentId: suggestion.parentId,
            }));
          this.setState({
            criteriaMapByUser: criteriaMapByUser,
            propertiesMapByUser: propertiesMapByUser,
          });
        }
      })
      .catch(error => {
        // Error
        let errorMessage;
        if (error.response) {
          errorMessage = error.response.data.message;
        } else if (error.request) {
          errorMessage = error.request;
        } else {
          errorMessage = error.message;
        }
        this.setState({
          errorMessage: errorMessage,
        });
      });
  };

  getAllCriterias = () => {
    axios
      .get('criteria/default')
      .then(response => {
        if (response.data) {
          let group = response.data.parentCriteriaInfo.map(suggestion => ({
            value: suggestion.id,
            label: suggestion.name,
          }));
          let properties = response.data.childCriteriaInfo.map(suggestion => ({
            value: suggestion.id,
            label: suggestion.name,
            parentId: suggestion.parentId,
          }));
          this.setState({
            group: group,
            properties: properties,
          });
          this.getMyCriteria();
        }
      })
      .catch(error => {
        // Error
        let errorMessage;
        if (error.response) {
          errorMessage = error.response.data.message;
        } else if (error.request) {
          errorMessage = error.request;
        } else {
          errorMessage = error.message;
        }
        this.setState({
          errorMessage: errorMessage,
        });
      });
  };

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  handleChangeGroup = name => value => {
    this.setState({
      [name]: value,
      selectedProperties: null,
    });
    if (value !== null) {
      let suggestionProperties = this.state.properties.filter(item => {
        return item.parentId === value.value;
      });
      this.setState({ suggestionProperties });
    }
  };

  handleChangeProperties = name => value => {
    this.setState({
      [name]: value,
      selectedCriteriaForDelete: null,
      selectedPropertieForDelete: null,
    });
    if (
      value !== null &&
      (this.state.choiceForAddRemove === 'Remove' ||
        this.state.choiceForAddRemove === 'Rename')
    ) {
      let suggestionCriteria = this.state.criteriaMapByUser.filter(item => {
        return item.parentId === value.value;
      });
      this.setState({ suggestionCriteria });
    }
  };

  handleChangeDeleteCriteria = name => value => {
    this.setState({
      [name]: value,
    });
  };

  addNewCriteria = criteriaName => {
    let parentId;
    if (this.state.choiceForAdding !== 'Property') {
      parentId = this.state.selectedProperties.value;
    } else {
      parentId = 332;
      // this is fixed id for adding Properties, ina db this is Other card
    }
    axios
      .post('criteria', {
        name: criteriaName,
        parentId: parentId,
      })
      .then(response => {
        if (response.data) {
          var msg = response.data.message;
          this.setState({
            selectedGroup: null,
            selectedProperties: null,
            suggestionProperties: null,
            suggestionCriteria: [],
            errorMessage: '',
            choiceForAdding: 'Criteria',
            choiceForAddRemove: 'Add',
            criteriaName: '',
            selectedCriteriaForDelete: null,
            selectedPropertieForDelete: null,
            msg: msg,
            openSnackbar: true,
          });

          this.getAllCriterias();
          // this.getMyCriteria();
        }
      })
      .catch(error => {
        // Error
        let errorMessage;
        if (error.response) {
          errorMessage = error.response.data.message;
        } else if (error.request) {
          errorMessage = error.request;
        } else {
          errorMessage = error.message;
        }
        this.setState({
          selectedGroup: null,
          selectedProperties: null,
          criteriaName: '',
          msg: errorMessage.slice(20),
          openSnackbar: true,
        });
      });
  };

  removeCriteria = criteriaName => {
    let id;
    if (
      this.state.choiceForAdding === 'Property' &&
      this.state.choiceForAddRemove === 'Remove'
    ) {
      id = this.state.selectedPropertieForDelete.value;
    } else {
      id = this.state.selectedCriteriaForDelete.value;
    }
    axios
      .delete('criteria/' + id)
      .then(response => {
        if (response.data) {
          var msg = response.data.message;
          this.setState({
            selectedGroup: null,
            selectedProperties: null,
            suggestionProperties: null,
            suggestionCriteria: [],
            errorMessage: '',
            choiceForAdding: 'Criteria',
            choiceForAddRemove: 'Add',
            criteriaName: '',
            selectedCriteriaForDelete: null,
            selectedPropertieForDelete: null,
            msg: msg,
            openSnackbar: true,
          });
          this.getAllCriterias();
          // this.getMyCriteria();
        }
      })
      .catch(error => {
        // Error
        let errorMessage;
        if (error.response) {
          errorMessage = error.response.data.message;
        } else if (error.request) {
          errorMessage = error.request;
        } else {
          errorMessage = error.message;
        }
        this.setState({
          selectedGroup: null,
          selectedProperties: null,
          criteriaName: '',
          msg: errorMessage.slice(20),
          openSnackbar: true,
        });
      });
  };

  renameCriteria = criteriaName => () => {
    let id;
    if (
      this.state.choiceForAdding === 'Property' &&
      this.state.choiceForAddRemove === 'Rename'
    ) {
      id = this.state.selectedPropertieForDelete.value;
    } else {
      id = this.state.selectedCriteriaForDelete.value;
    }
    let parentId;
    if (this.state.choiceForAdding !== 'Property') {
      parentId = this.state.selectedProperties.value;
    } else {
      parentId = 332;
      // this is fixed id for adding Properties, ina db this is Other card
    }
    axios
      .put('criteria/' + id, {
        name: criteriaName,
        parentId: parentId,
      })
      .then(response => {
        if (response.data) {
          var msg = response.data.message;
          this.setState({
            selectedGroup: null,
            selectedProperties: null,
            suggestionProperties: null,
            suggestionCriteria: null,
            errorMessage: '',
            choiceForAdding: 'Criteria',
            choiceForAddRemove: 'Add',
            criteriaName: '',
            selectedCriteriaForDelete: null,
            selectedPropertieForDelete: null,
            msg: msg,
            openSnackbar: true,
          });
          this.getAllCriterias();
          // this.getMyCriteria();
        }
      })
      .catch(error => {
        // Error
        let errorMessage;
        if (error.response) {
          errorMessage = error.response.data.message;
        } else if (error.request) {
          errorMessage = error.request;
        } else {
          errorMessage = error.message;
        }
        this.setState({
          selectedGroup: null,
          selectedProperties: null,
          criteriaName: '',
          criteriaNameEdited: '',
          msg: errorMessage.slice(20),
          openSnackbar: true,
        });
      });
  };

  onSubmit = criteriaName => () => {
    this.state.choiceForAddRemove === 'Add'
      ? this.addNewCriteria(criteriaName)
      : this.removeCriteria(criteriaName);
  };

  handleChangeChoiceForAdding = event => {
    this.setState({
      choiceForAdding: event.target.value,
      selectedGroup: null,
      selectedProperties: null,
      criteriaName: '',
      criteriaNameEdited: '',
      selectedCriteriaForDelete: null,
      selectedPropertieForDelete: null,
    });
  };

  handleChangeChoiceForAddRemove = event => {
    this.setState(
      {
        selectedGroup: null,
        selectedProperties: null,
        selectedCriteriaForDelete: null,
        selectedPropertieForDelete: null,
        choiceForAdding: 'Criteria',
        criteriaName: '',
        criteriaNameEdited: '',
        suggestionProperties: null,
        suggestionCriteria: [],
        choiceForAddRemove: event.target.value,
      },
      () => {
        this.getAllCriterias();
        // this.getMyCriteria();
      }
    );
  };

  render() {
    const { classes, theme } = this.props;
    const selectStyles = {
      input: base => ({
        ...base,
        color: theme.palette.text.primary,
        '& input': {
          font: 'inherit',
        },
      }),
    };
    return (
      <div>
        <FormControl component="fieldset">
          {/* <FormLabel component="legend"> Add new:</FormLabel> */}
          <RadioGroup
            aria-label="choiceForAddRemove"
            name="choiceForAddRemove"
            // className={classes.group}
            value={this.state.choiceForAddRemove}
            onChange={this.handleChangeChoiceForAddRemove}
            row
          >
            <FormControlLabel value="Add" control={<Radio />} label="Add" />
            <FormControlLabel
              value="Remove"
              control={<Radio />}
              label="Remove"
            />
            <FormControlLabel
              value="Rename"
              control={<Radio />}
              label="Rename"
            />
          </RadioGroup>
          <RadioGroup
            aria-label="choiceForAdding"
            name="choiceForAdding"
            // className={classes.group}
            value={this.state.choiceForAdding}
            onChange={this.handleChangeChoiceForAdding}
            row
          >
            <FormControlLabel
              value="Property"
              control={<Radio />}
              label="Luminaire property"
            />
            <FormControlLabel
              value="Criteria"
              control={<Radio />}
              label="Requirement"
            />
          </RadioGroup>
        </FormControl>
        <DialogContent
          classes={{
            root: 'no-padding',
          }}
        >
          {this.state.choiceForAdding === 'Property' ? null : (
            <React.Fragment>
              <NoSsr>
                <Select
                  fullWidth
                  classes={classes}
                  styles={selectStyles}
                  options={this.state.group}
                  components={components}
                  value={this.state.selectedGroup}
                  onChange={this.handleChangeGroup('selectedGroup')}
                  placeholder="Search a category"
                  isClearable
                  // defaultValue={this.state.selectedGroup}
                />
              </NoSsr>
              {this.state.selectedGroup !== null && (
                <NoSsr>
                  <Select
                    fullWidth
                    classes={classes}
                    styles={selectStyles}
                    options={this.state.suggestionProperties}
                    components={components}
                    defaultValue={this.state.selectedProperties}
                    onChange={this.handleChangeProperties('selectedProperties')}
                    placeholder="Search a luminaire property"
                    isClearable
                  />
                </NoSsr>
              )}
            </React.Fragment>
          )}

          {(this.state.selectedProperties !== null &&
            this.state.selectedGroup !== null) ||
          this.state.choiceForAdding === 'Property' ? (
            this.state.choiceForAddRemove === 'Add' ? (
              <FormControl fullWidth>
                <Input
                  // error={errors.criteriaName && touched.criteriaName}
                  classes={{
                    underline: 'underline--c-black',
                  }}
                  name="criteriaName"
                  type="text"
                  label="Input name"
                  value={this.state.criteriaName}
                  onChange={this.handleChange('criteriaName')}
                  placeholder={
                    this.state.choiceForAdding === 'Property'
                      ? 'Property'
                      : 'Requirement'
                  }
                />
              </FormControl>
            ) : this.state.choiceForAdding !== 'Property' ? (
              <NoSsr>
                <Select
                  fullWidth
                  classes={classes}
                  styles={selectStyles}
                  options={this.state.suggestionCriteria}
                  components={components}
                  defaultValue={this.state.selectedCriteriaForDelete}
                  onChange={this.handleChangeDeleteCriteria(
                    'selectedCriteriaForDelete'
                  )}
                  placeholder="Search a requirement"
                  isClearable
                />
              </NoSsr>
            ) : (
              <NoSsr>
                <Select
                  fullWidth
                  classes={classes}
                  styles={selectStyles}
                  options={this.state.propertiesMapByUser}
                  components={components}
                  value={this.state.selectedPropertieForDelete}
                  onChange={this.handleChangeDeleteCriteria(
                    'selectedPropertieForDelete'
                  )}
                  placeholder="Search a category"
                  isClearable
                  // defaultValue={this.state.selectedGroup}
                />
              </NoSsr>
            )
          ) : null}

          {this.state.choiceForAddRemove === 'Rename' &&
          this.state.choiceForAddin === 'Criteria' &&
          this.state.selectedCriteriaForDelete
            ? 'prikazi'
            : null}

          {(this.state.choiceForAddRemove === 'Rename' &&
            this.state.choiceForAdding === 'Property' &&
            this.state.selectedPropertieForDelete) ||
          (this.state.choiceForAddRemove === 'Rename' &&
            this.state.choiceForAdding === 'Criteria' &&
            this.state.selectedCriteriaForDelete) ? (
            <FormControl fullWidth>
              <Input
                classes={{
                  underline: 'underline--c-black',
                }}
                name="criteriaNameEdit"
                type="text"
                label="Criteria name"
                value={this.state.criteriaNameEdited}
                onChange={this.handleChange('criteriaNameEdited')}
                placeholder={
                  this.state.choiceForAdding === 'Property'
                    ? 'Rename property'
                    : 'Rename requirement'
                }
              />
            </FormControl>
          ) : null}
        </DialogContent>
        <div className="dialog-separator" />
        <DialogActions className="u-mrg-right-0">
          {/* TO DO refactoring for logic in buttons needed */}
          {this.state.choiceForAddRemove !== 'Rename' && (
            <Button
              disabled={
                this.state.choiceForAddRemove === 'Add'
                  ? this.state.criteriaName === ''
                  : this.state.choiceForAdding === 'Criteria'
                  ? this.state.selectedCriteriaForDelete === null
                  : this.state.selectedPropertieForDelete === null
              }
              variant="contained"
              color="primary"
              className="t-weight-b pointer u-mrg-right-0"
              onClick={this.onSubmit(
                this.state.criteriaName,
                this.state.choiceForAddRemove
              )}
            >
              {this.state.choiceForAddRemove === 'Add' ? 'Add' : 'Remove'}
            </Button>
          )}
          {this.state.choiceForAddRemove === 'Rename' && (
            <Button
              disabled={this.state.criteriaNameEdited === ''}
              variant="contained"
              color="primary"
              className="t-weight-b pointer u-mrg-right-0"
              onClick={this.renameCriteria(this.state.criteriaNameEdited)}
            >
              Rename
            </Button>
          )}
        </DialogActions>
        <Snackbar
          open={this.state.openSnackbar}
          msg={this.state.msg}
          onClose={this.handleCloseSncakbar}
        />
      </div>
    );
  }
}

AddNewCriteriaDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(AddNewCriteriaDialog);
